// src/components/HelpBar.jsx
import React, { useEffect, useState } from "react";

export default function HelpBar({ storageKey = "leads_helpbar_dismissed", children }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const off = localStorage.getItem(storageKey) === "1";
    setVisible(!off);
  }, [storageKey]);

  if (!visible) return null;

  return (
    <div
      role="note"
      aria-label="Dicas de uso"
      style={{
        border: "1px dashed #cbd5e1",
        background: "#f9fafb",
        color: "#374151",
        borderRadius: 10,
        padding: "10px 12px",
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        marginBottom: 10,
      }}
    >
      <div style={{ fontSize: 13, lineHeight: 1.4, flex: 1 }}>{children}</div>
      <button
        type="button"
        aria-label="Ocultar dicas"
        title="Não mostrar novamente"
        onClick={() => { localStorage.setItem(storageKey, "1"); setVisible(false); }}
        style={{
          border: "1px solid #e5e7eb",
          background: "#fff",
          borderRadius: 8,
          padding: "6px 10px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Entendi
      </button>
    </div>
  );
}
